$item_width_xs: 90px;
$item_width_sm: 120px;
$item_width_md: 150px;
$item_width_lg: 180px;
$item_width_xl: 210px;

.fl_grid_item {
	aspect-ratio: 1;
	border-radius: 8px;
	border: 1px solid var(--axl-hair);
	box-shadow: var(--axl-shadow-1);
	transition: box-shadow var(--axl-dur) var(--axl-ease), transform var(--axl-dur) var(--axl-ease-out);

	&[data-size="xs"] {
		width: $item_width_xs;
		max-width: $item_width_xs;
	}

	&[data-size="sm"] {
		width: $item_width_sm;
		max-width: $item_width_sm;
	}

	&[data-size="md"] {
		width: $item_width_md;
		max-width: $item_width_md;
	}

	&[data-size="lg"] {
		width: $item_width_lg;
		max-width: $item_width_lg;
	}

	&[data-size="xl"] {
		width: $item_width_xl;
		max-width: $item_width_xl;
	}

	&:hover {
		box-shadow: var(--axl-shadow-2-hover);

		.fl_overlay {
			opacity: 1;
		}

		.fl_bottom_panel {
			opacity: 1;
			transform: translateY(0);
		}
	}

	// Disable transitions during drag
	&[style*="transform"] {
		transition: none !important;
	}
}

// Drag Handle
.fl_drag_handle {
	position: absolute;
	top: 5px;
	left: 50%;
	margin-left: -12px; // Half of width (24px) to center
	background: rgba(0, 0, 0, 0.7);
	border-radius: 4px;
	padding: 4px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
	transition: all 0.2s ease;
	color: white;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;

	svg {
		transform: rotate(90deg);
		color: white;
	}

	&:hover {
		background: rgba(0, 0, 0, 0.8);
		transform: scale(1.1);
	}
}

// Background - Full size image or icon
.fl_background {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
}

.fl_background_preview {
	width: 100% !important;
	height: 100% !important;
	border-radius: 8px;
	overflow: hidden;
}

// Overlay with actions - only visible on hover
.fl_overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(to bottom,
			rgba(0, 0, 0, 0.4) 0%,
			rgba(0, 0, 0, 0.6) 50%,
			rgba(0, 0, 0, 0.8) 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 0;
	transition: opacity 0.3s ease;
}

.fl_actions {
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10;

	// Ensure action buttons are visible
	.ant-btn {
		background: rgba(255, 255, 255, 0.9) !important;
		border: 1px solid rgba(255, 255, 255, 0.3) !important;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;

		&:hover {
			background: rgba(255, 255, 255, 1) !important;
			transform: scale(1.1);
		}

		.anticon {
			color: #333 !important;
		}
	}
}

// Bottom panel with file info
.fl_bottom_panel {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	background: linear-gradient(transparent, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6));
	padding: 20px 10px 10px 10px;
	opacity: 0;
	transition: all 0.4s ease;
}

.fl_file_name {
	margin-bottom: 4px;

	color: white;
	font-weight: 600;
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
	font-size: 12px;
}

.fl_file_info {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 11px;

	span {
		color: rgba(255, 255, 255, 0.9);
		text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
		font-weight: 500;
	}
}
